var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.846,
    height: 57.122,
    viewBox: "0 0 13.846 57.122"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(3810.075 -272.169) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(272.169 3797.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M-9.479-170.708l9.279-6-9.279-6Z",
    transform: "translate(56.402 182.716)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 46.924,
    transform: "translate(0 6.004)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMTMuODQ2IgogIGhlaWdodD0iNTcuMTIyIgogIHZpZXdCb3g9IjAgMCAxMy44NDYgNTcuMTIyIgo+CiAgPGcKICAgIGlkPSJHcm91cF8yOTciCiAgICBkYXRhLW5hbWU9Ikdyb3VwIDI5NyIKICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM4MTAuMDc1IC0yNzIuMTY5KSByb3RhdGUoOTApIgogID4KICAgIDxnCiAgICAgIGlkPSJHcm91cF8xMCIKICAgICAgZGF0YS1uYW1lPSJHcm91cCAxMCIKICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjcyLjE2OSAzNzk3LjE0OCkiCiAgICA+CiAgICAgIDxwYXRoCiAgICAgICAgaWQ9IlBhdGhfMjciCiAgICAgICAgZGF0YS1uYW1lPSJQYXRoIDI3IgogICAgICAgIGQ9Ik0tOS40NzktMTcwLjcwOGw5LjI3OS02LTkuMjc5LTZaIgogICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU2LjQwMiAxODIuNzE2KSIKICAgICAgICBmaWxsPSJub25lIgogICAgICAgIHN0cm9rZT0iI2ZmZiIKICAgICAgICBzdHJva2Utd2lkdGg9IjEiCiAgICAgIC8+CiAgICAgIDxsaW5lCiAgICAgICAgaWQ9IkxpbmVfMSIKICAgICAgICBkYXRhLW5hbWU9IkxpbmUgMSIKICAgICAgICB4Mj0iNDYuOTI0IgogICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNi4wMDQpIgogICAgICAgIGZpbGw9Im5vbmUiCiAgICAgICAgc3Ryb2tlPSIjZmZmIgogICAgICAgIHN0cm9rZS13aWR0aD0iMSIKICAgICAgLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgArrowDown as ReactComponent };